import { TOGGLE_HELP } from "constants/actions";

export function toggleHelp(isToggle) {
    return {
        type: TOGGLE_HELP.TOGGLE_HELP_INFO,
        isToggle
    };
}